import React, { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Typography } from "antd";
import ChromaKeyVideo from "./ChromaKeyVideo";
import loadingBirdVideo from "../assets/LoadingBird.mp4";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const MIN_BAR_DURATION = 3000;
const MAX_BAR_DURATION = 5000;

const getRandomBarDuration = () =>
  MIN_BAR_DURATION + Math.random() * (MAX_BAR_DURATION - MIN_BAR_DURATION);

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const [progress, setProgress] = useState(0);
  const [barComplete, setBarComplete] = useState(false);
  const durationRef = useRef(getRandomBarDuration());

  useEffect(() => {
    let rafId: number;
    const start = performance.now();
    const duration = durationRef.current;

    const tick = (now: number) => {
      const elapsed = now - start;
      const percent = Math.min(100, (elapsed / duration) * 100);
      setProgress(percent);

      if (percent >= 100) {
        setBarComplete(true);
        return;
      }
      rafId = requestAnimationFrame(tick);
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, []);

  if (!barComplete || loading) {
    return (
      <div className="app-loading-screen">
        <ChromaKeyVideo className="app-loading-video" src={loadingBirdVideo} />
        <div className="app-loading-bar-track">
          <div
            className="app-loading-bar-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
        <Typography.Text style={{ color: "#fff", fontWeight: 600 }}>
          Cargando experiencia...
        </Typography.Text>
      </div>
    );
  }

  return user ? <>{children}</> : <Navigate to="/login" />;
};

export default PrivateRoute;
